module.exports = ".company-toggle {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n}\n\n.company-toggle .form-group {\n    margin-right: 30px;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/views/companies/companies.component.css
// module id = ./src/app/views/companies/companies.component.css
// module chunks = main